import { useTranslation } from 'react-i18next';

const DropDownEmpty = () => {
  const { t } = useTranslation();

  return <div className="p-3 text-center">{t('noResults')}</div>;
};

export default DropDownEmpty;
